var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import React, { useEffect, useState } from "react";
var GenericTooltip = function (props) {
    var _a = __read(useState(false), 2), show = _a[0], setShow = _a[1];
    var _b = __read(useState(props.isExist), 2), isToggle = _b[0], setIsToggle = _b[1];
    useEffect(function () {
        if (Object(props).hasOwnProperty("isExist")) {
            setShow(props.isExist);
            setIsToggle(props.isExist);
        }
    }, [props.isExist]);
    useEffect(function () {
        // added hasOuterShowState so it doesn't hamper the functionality of the component when it is used in other components
        if (props.hasOuterShowState) {
            setShow(function () { return props.showTooltip; });
        }
    }, [props === null || props === void 0 ? void 0 : props.showTooltip, show]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: props.externalClassName }, props.triggerType === "hover" ? (React.createElement(OverlayTrigger, __assign({ container: function () { return document.getElementById("tooltip-container"); }, trigger: ["hover", "focus"], key: props.placement, placement: props.placement, show: props.showTooltip, overlay: React.createElement(Tooltip, { id: "overlay-example", className: props.toolTipClassName }, props.toolTipText) }, (props.container && { container: props.container })), props.noButton ? (React.createElement("div", { onClick: function () { return setShow(!show); } }, props.button)) : (React.createElement(Button, { onClick: function () { return setShow(!show); } }, props.button)))) : (React.createElement(OverlayTrigger, __assign({ container: function () { return document.getElementById("tooltip-container"); }, show: show, onToggle: function () { return setIsToggle(false); }, trigger: "click", key: props.placement, placement: props.placement, overlay: React.createElement(Tooltip, { id: "overlay-example", className: "".concat(props.toolTipClassName, " ").concat(isToggle && "d-none") }, props.toolTipText) }, (props.container && { container: props.container })), props.noButton ? (React.createElement("div", { onClick: function () { return setShow(!show); } }, show
            ? props.onShowbutton
                ? props.onShowbutton
                : props.button
            : props.button)) : (React.createElement(Button, { onClick: function () { return setShow(!show); } }, show
            ? props.onShowbutton
                ? props.onShowbutton
                : props.button
            : props.button)))))));
};
export default GenericTooltip;
